import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'cause-of-maintance',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `cause-of-maintance`,
    method: 'get',
    params: queriesParams
  })
}

export function addCauseOfMaintance (causeOfMaintance) {
  return request({
    method: 'post',
    url: 'cause-of-maintance',
    data: causeOfMaintance
  })
}

export function show (id) {
  return request({
    url: `cause-of-maintance/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `cause-of-maintance/${id}`,
    method: 'patch',
    data
  })
}
